<template>
	<div class="footerBox">
		<div class="coverBox" v-if="flag" @click="flag = false">
			<div class="cont mainCont">
				<h4>扫码关注小程序，下单方便又快捷</h4>
				<img src="../../../static/ma.jpg" alt="ma" class="img">
			</div>
		</div>
		<div class="box1">
			<div class="cont mainCont">
				<ul class="b_left">
					<li class="mr185">
						<h3 class="tit">联系我们</h3>
						<a :href="'tel:'+tel" class="tel">{{tel}}</a>
						<p>客服时间：08:30-20:30</p>
					</li>
					<li class="mr76">
						<a href="/"><h3 class="tit">首页</h3></a>
						<router-link to="/server"><p class="p_a mb">服务项目</p></router-link>
						<router-link to="/case"><p class="p_a">案例</p></router-link>
					</li>
					<li class="mr76">
						
					<router-link to="/reservation"><h3 class="tit">鲸蜗家庭报修</h3></router-link>
					<router-link to="/master"><p class="p_a">师傅展示</p></router-link>
					</li>
				</ul>
				<div class="img"><img src="../../../static/ma.jpg" alt="ma"></div>
			</div>
		</div>
		<div class="box2">版权所有 ©2015-2030 appsaa.com 赣ICP备2024029599号</div>
	</div>
</template>

<script>
export default {
	name: 'Navbar',
	components: {},
	props:{
		tel:{
			type:String,
			default:''
		}
	},
	data() {
		return {
			flag:true,
		};
	},
	methods: {

	},
};
</script>

<style lang="scss" scoped>
.footerBox{background-color: #1B1E2D;position: relative;
	.box1{padding: 55px 0;
		.cont{display: flex;align-items: center;justify-content: space-between;
			.b_left{display: flex;align-items: center;
				.tit{font-size: 18px;color: #fff;margin-bottom: 24px;}
				.tel{color: #2F78FF;font-size: 22px;font-weight: bold;display: block;margin-bottom: 6px;}
				p{font-size: 14px;color: rgba(255,255,255,0.5);
					&.p_a{cursor: pointer;
						&:hover{color:#2F78FF;}
						&.mb{margin-bottom: 20px;}
					}
				}
				.mr185{margin-right: 185px;}
				.mr76{margin-right:76px;}

			}
			.img{width: 131px;height: 131px;background-color: #fff;
				img{width: 131px;height: 131px;}
			}
		}
	}
	.box2{line-height: 50px;height: 50px;background-color: #272A39;color: #B7BBCF;font-size: 12px;text-align: center;}
	.coverBox{height: 100px;background: rgba(0,0,0,0.5);position: fixed;left: 0;right: 0;bottom: 0;width: 100%;z-index: 10;
		.cont{position: relative;
			h4{line-height: 100px;color: #FFFFFF;font-size: 26px;text-align: center;}
			.img{width: 120px;height: 120px;background: #D9D9D9;border-radius: 15px;position: absolute;top: -40px;right: 112px;}
		}
	}
}
</style>



// WEBPACK FOOTER //
// src/layout/components/footer.vue